export default {
      id: "flag-no-usage",
      viewBox: "0 10 36 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#flag-no",
      toString: function () {
        return this.url;
      }
    }